import type { IGetCommentResponse } from "./types"

/** После PUT реакции / текста: слить поля из CommentResource, сохранить children в кэше. */
export function patchCommentNodePreserveChildren(
    roots: IGetCommentResponse[],
    commentId: number,
    apiNode: IGetCommentResponse
): IGetCommentResponse[] {
    return roots.map((node) => {
        if (node.id === commentId) {
            return {
                ...node,
                ...apiNode,
                children: node.children,
                // Reaction/update payload may omit withCount('children') → 0; keep list/thread CTA counters.
                counters: {
                    children: Number(node.counters?.children ?? apiNode.counters?.children ?? 0),
                    likes: Number(apiNode.counters?.likes ?? node.counters?.likes ?? 0),
                    dislikes: Number(apiNode.counters?.dislikes ?? node.counters?.dislikes ?? 0),
                },
            }
        }
        if (node.children?.length) {
            return {
                ...node,
                children: patchCommentNodePreserveChildren(node.children, commentId, apiNode),
            }
        }
        return node
    })
}
